<template>
    <b-overlay :show="showLoader" class="bussinesCondition">
        <b-card title="Splošni pogoji poslovanja" class="w-100">
                
            <b-row v-if="$hasPermissions($permissions.EditPages)">
                <b-col cols="12" sm="6" class="text-center text-sm-left">
                    <b-button variant="primary" @click="$router.push('/dodaj/pogoje-poslovanja/basic')">Dodaj pogoje</b-button>
                </b-col>
            </b-row>
    
            <div v-if="basicConditions && basicConditions.length > 0">
                <b-alert v-if="!hasBeenDeleted && $hasPermissions($permissions.EditPages)" class="my-1 p-1 text-center" show variant="warning">Z vlečenjem vrstic lahko spremenite vrstni red prikaza na spletni strani.</b-alert>
                <b-alert v-else-if="$hasPermissions($permissions.EditPages)" class="mt-1 p-1 text-center" show variant="warning">Po brisanju je potrebnih nekaj sekund, da je brisanje izvedeno. Če so pogoji po brisanju še vedno vidni, ponovno naložite stran.</b-alert>
    
                <div class="row mt-3 pb-1 header">
                    <div class="col-4">
                        Naslov
                    </div>
                    <div class="col-8">
                        Vsebina
                    </div>
                </div>
    
                <draggable
                    v-model="basicConditions"
                    tag="ul"
                    class="list-group list-group-flush cursor-move"
                    id="drag"
                    :disabled="!$hasPermissions($permissions.EditPages)"
                >
    
                    <b-list-group-item
                        v-for="(item, index) in basicConditions"
                        :key="index"
                        tag="li"
                        class="p-0 py-1"
                    >
                        <div class="row d-flex align-items-center">
                            <div class="col-4">
                                {{item.title}}
                            </div>
                            <div class="col-5 cut-text" v-html="item.content"/>
                            <div class="col-3 d-flex justify-content-center" v-if="$hasPermissions($permissions.EditPages)">
                                <b-button variant="warning mr-2" @click="$router.push({name: 'business-condition-edit', params: {id: item.id}})"><fa icon="edit"/></b-button>
                                <b-button variant="danger" @click="deleteObject(item.id)"><fa icon="trash"/></b-button>
                            </div>
                        </div>
                    </b-list-group-item>
                </draggable>
                <div class="d-flex justify-content-end mt-2" v-if="$hasPermissions($permissions.EditPages)">
                    <b-button class="mt-2" variant="primary" @click="basicSaveOrder()">Shrani vrstni red</b-button>
                </div>
            </div>
    
            <div class="mt-2" v-else>
                <b-alert class="p-1 text-center" show variant="warning">Ni dodanih pogojev poslovanja</b-alert>
            </div>
    
        </b-card>
        <b-card title="Pogoji poslovanja Habit d.o.o." class="w-100">
                
            <b-row v-if="$hasPermissions($permissions.EditPages)">
                <b-col cols="12" sm="6" class="text-center text-sm-left">
                    <b-button variant="primary" @click="$router.push('/dodaj/pogoje-poslovanja/habit')">Dodaj pogoje</b-button>
                </b-col>
            </b-row>

            <div v-if="habitConditions && habitConditions.length > 0">
                <b-alert v-if="!hasBeenDeleted && $hasPermissions($permissions.EditPages)" class="my-1 p-1 text-center" show variant="warning">Z vlečenjem vrstic lahko spremenite vrstni red prikaza na spletni strani.</b-alert>
                <b-alert v-else-if="$hasPermissions($permissions.EditPages)" class="mt-1 p-1 text-center" show variant="warning">Po brisanju je potrebnih nekaj sekund, da je brisanje izvedeno. Če so pogoji po brisanju še vedno vidni, ponovno naložite stran.</b-alert>

                <div class="row mt-3 pb-1 header">
                    <div class="col-4">
                        Naslov
                    </div>
                    <div class="col-8">
                        Vsebina
                    </div>
                </div>

                <draggable
                    v-model="habitConditions"
                    tag="ul"
                    class="list-group list-group-flush cursor-move"
                    id="drag"
                    :disabled="!$hasPermissions($permissions.EditPages)"
                >

                    <b-list-group-item
                        v-for="(item, index) in habitConditions"
                        :key="index"
                        tag="li"
                        class="p-0 py-1"
                    >
                        <div class="row d-flex align-items-center">
                            <div class="col-4">
                                {{item.title}}
                            </div>
                            <div class="col-5 cut-text" v-html="item.content"/>
                            <div class="col-3 d-flex justify-content-center" v-if="$hasPermissions($permissions.EditPages)">
                                <b-button variant="warning mr-2" @click="$router.push({name: 'business-condition-edit', params: {id: item.id}})"><fa icon="edit"/></b-button>
                                <b-button variant="danger" @click="deleteObject(item.id)"><fa icon="trash"/></b-button>
                            </div>
                        </div>
                    </b-list-group-item>
                </draggable>
                <div class="d-flex justify-content-end mt-2" v-if="$hasPermissions($permissions.EditPages)">
                    <b-button class="mt-2" variant="primary" @click="habitSaveOrder()">Shrani vrstni red</b-button>
                </div>
            </div>

            <div class="mt-2" v-else>
                <b-alert class="p-1 text-center" show variant="warning">Ni dodanih pogojev poslovanja</b-alert>
            </div>

        </b-card>
        <b-card title="Pogoji poslovanja Staninvest d.o.o." class="w-100">
                
            <b-row v-if="$hasPermissions($permissions.EditPages)">
                <b-col cols="12" sm="6" class="text-center text-sm-left">
                    <b-button variant="primary" @click="$router.push('/dodaj/pogoje-poslovanja/stanInvest')">Dodaj pogoje</b-button>
                </b-col>
            </b-row>
    
            <div v-if="stanInvsetConditions && stanInvsetConditions.length > 0">
                <b-alert v-if="!hasBeenDeleted && $hasPermissions($permissions.EditPages)" class="my-1 p-1 text-center" show variant="warning">Z vlečenjem vrstic lahko spremenite vrstni red prikaza na spletni strani.</b-alert>
                <b-alert v-else-if="$hasPermissions($permissions.EditPages)" class="mt-1 p-1 text-center" show variant="warning">Po brisanju je potrebnih nekaj sekund, da je brisanje izvedeno. Če so pogoji po brisanju še vedno vidni, ponovno naložite stran.</b-alert>
    
                <div class="row mt-3 pb-1 header">
                    <div class="col-4">
                        Naslov
                    </div>
                    <div class="col-8">
                        Vsebina
                    </div>
                </div>
    
                <draggable
                    v-model="stanInvsetConditions"
                    tag="ul"
                    class="list-group list-group-flush cursor-move"
                    id="drag"
                    :disabled="!$hasPermissions($permissions.EditPages)"
                >
    
                    <b-list-group-item
                        v-for="(item, index) in stanInvsetConditions"
                        :key="index"
                        tag="li"
                        class="p-0 py-1"
                    >
                        <div class="row d-flex align-items-center">
                            <div class="col-4">
                                {{item.title}}
                            </div>
                            <div class="col-5 cut-text" v-html="item.content"/>
                            <div class="col-3 d-flex justify-content-center" v-if="$hasPermissions($permissions.EditPages)">
                                <b-button variant="warning mr-2" @click="$router.push({name: 'business-condition-edit', params: {id: item.id}})"><fa icon="edit"/></b-button>
                                <b-button variant="danger" @click="deleteObject(item.id)"><fa icon="trash"/></b-button>
                            </div>
                        </div>
                    </b-list-group-item>
                </draggable>
                <div class="d-flex justify-content-end mt-2" v-if="$hasPermissions($permissions.EditPages)">
                    <b-button class="mt-2" variant="primary" @click="stanInvestSaveOrder()">Shrani vrstni red</b-button>
                </div>
            </div>
    
            <div class="mt-2" v-else>
                <b-alert class="p-1 text-center" show variant="warning">Ni dodanih pogojev poslovanja</b-alert>
            </div>
    
        </b-card>
    </b-overlay>
</template>

<script>
    import draggable from 'vuedraggable'
    import {BListGroupItem, BAlert, BButton, BOverlay, BCard, BRow, BCol} from 'bootstrap-vue'
    export default {
        components: {
            // Table,
            draggable,
            BListGroupItem,
            BAlert,
            BButton,
            BOverlay,
            BCard,
            BRow,
            BCol
        },
        data() {
            return {
                showLoader: false,
                basicConditions: [],
                habitConditions: [],
                stanInvsetConditions: [],
                hasBeenDeleted: false
            }
        },
        methods:{
            async deleteObject(id) {
                this.hasBeenDeleted = false
                const deleteConfirmationResult = await this.$bvModal.msgBoxConfirm('Prosimo potrdite, da želite izbrisati pogoj.', {
                    size: 'sm',
                    okTitle: 'Da',
                    cancelTitle: 'Ne',
                    hideHeaderClose: false,
                    okVariant: 'danger',
                    cancelVariant: 'outline-secondary',
                    centered: true
                })
                if (!deleteConfirmationResult) return

                try {

                    await this.$http.delete(`/api/management/v1/business_condition/${id}`)
                    this.hasBeenDeleted = true
                    this.$printSuccess('Pogoj je bil izbrisan')
                    await this.loadData()

                } catch (err) {
                    this.$printError(err)
                }

            },
            async loadData() {
                try {
                    this.showLoader = true

                    const responseBasic = await this.$http.get('/api/management/v1/business_condition/manager/basic')
                    this.basicConditions = responseBasic.data

                    const responseHabit = await this.$http.get('/api/management/v1/business_condition/manager/habit')
                    this.habitConditions = responseHabit.data

                    const responseStanInvest = await this.$http.get('/api/management/v1/business_condition/manager/stanInvest')
                    this.stanInvsetConditions = responseStanInvest.data
                } catch (err) {
                    this.$printError(err)
                } finally {
                    this.showLoader = false
                }
            },
            updateSortPlace(object, manager) {
                return this.$http.patch(`/api/management/v1/business_condition/sort/${object.id}/${manager}`, object)
            },
            async basicSaveOrder() {
                try {
                    for (const id in this.basicConditions) {

                        const index = parseInt(id)

                        if (index + 1 !== this.basicConditions[index].sort) {
                            this.basicConditions[index].sort = index + 1
                            await this.updateSortPlace(this.basicConditions[index], 'habit')
                        }
                    }
                } catch (err) {
                    this.$printError('Prislo je do napake pri posodabljanju vrstnega reda')
                } finally {
                    this.$printSuccess('Vrstni red uspesno posodobljen')
                }
                
            },
            async habitSaveOrder() {
                try {
                    for (const id in this.habitConditions) {

                        const index = parseInt(id)

                        if (index + 1 !== this.habitConditions[index].sort) {
                            this.habitConditions[index].sort = index + 1
                            await this.updateSortPlace(this.habitConditions[index], 'habit')
                        }
                    }
                } catch (err) {
                    this.$printError('Prislo je do napake pri posodabljanju vrstnega reda')
                } finally {
                    this.$printSuccess('Vrstni red uspesno posodobljen')
                }
                
            },
            async stanInvestSaveOrder() {
                try {
                    for (const id in this.stanInvsetConditions) {

                        const index = parseInt(id)

                        if (index + 1 !== this.stanInvsetConditions[index].sort) {
                            this.stanInvsetConditions[index].sort = index + 1
                            await this.updateSortPlace(this.stanInvsetConditions[index], 'stanInvest')
                        }
                    }
                } catch (err) {
                    this.$printError('Prislo je do napake pri posodabljanju vrstnega reda')
                } finally {
                    this.$printSuccess('Vrstni red uspesno posodobljen')
                }
                
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style>
.bussinesCondition #drag .sortable-chosen{
    background: #eaf3f9;
}
.bussinesCondition .header{
    font-weight: bold;
    border-bottom: 1px solid grey ;
}
.bussinesCondition .cut-text{
    max-width: 100%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>